import React from 'react';
import {
	CancellationData,
	withCancellationContext,
} from '../../../context/CancellationProvider';
import DisabledOverlay from '../../DisabledOverlay';
import DraftCancellationSidebar from './DraftCancellationSidebar';
import IssuedCancellationSidebar from './IssuedCancellationSidebar';

interface Props {
	cancellationData: CancellationData;
}

const CancellationSidebar = (props: Props) => {
	const { cancellationData } = props;

	const { policy, selectedCancellation } = cancellationData;

	if (!policy || !selectedCancellation) {
		return <DisabledOverlay />;
	}

	if (
		selectedCancellation.state === 'issued' ||
		selectedCancellation.state === 'reinstated'
	) {
		return <IssuedCancellationSidebar />;
	} else {
		return <DraftCancellationSidebar />;
	}
};

export default withCancellationContext<Props>(CancellationSidebar);
